import * as React from "react";
import { Alert, AlertColor, Card, CardContent, CardHeader, Stack } from "@mui/material";
import { GcSystem } from "../../../../services/types/cclGrandCentralApiTypes";
import SystemApplicationDetail from "./systemApplicationDetail";
import AddApplicationDrawer from "./addApplicationDrawer";
import CclButton from "../../../../components/common/cclButtons/cclButton";
import CclAlertSnackbar from "../../../../components/common/cclAlertSnackbar";

export type SystemApplicationsProps = {
    system: GcSystem;
    readonly: boolean;
};

export const SystemApplications: React.FC<SystemApplicationsProps> = (props) => {
    const [showAddApplication, setShowAddApplication] = React.useState<boolean>(false);
    const [showSnackbar, setShowSnackbar] = React.useState<boolean>(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState<string>("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState<AlertColor | undefined>("info");

    const onDrawerClose = (snackBarSeverity?: AlertColor, snackbarMsg?: string) => {
        setShowAddApplication(false);
        if (snackBarSeverity && snackbarMsg) {
            setSnackbarSeverity(snackBarSeverity);
            setSnackbarMessage(snackbarMsg);
            setShowSnackbar(true);
        }
    };

    return (
        <>
            {showAddApplication ? (
                <AddApplicationDrawer
                    open={true}
                    onClose={(severity, msg) => onDrawerClose(severity, msg)}
                    systemId={props.system.systemId}
                    systemName={props.system.systemName}
                />
            ) : null}
            <Card variant="outlined" sx={{ width: 1, height: 1 }}>
                <CclAlertSnackbar
                    open={showSnackbar}
                    onClose={() => setShowSnackbar(false)}
                    message={snackbarMessage}
                    severity={snackbarSeverity}
                />
                <CardHeader
                    title={"Applications"}
                    action={
                        props.readonly ? null : (
                            <CclButton onClick={() => setShowAddApplication(true)} mode={"primary"}>
                                Add Application
                            </CclButton>
                        )
                    }
                />
                <CardContent sx={{ padding: "5px" }}>
                    <Stack spacing={1}>
                        {props.system.applications && props.system.applications.length > 0 ? (
                            props.system.applications.map((app, idx) => (
                                <SystemApplicationDetail
                                    key={app.applicationId}
                                    applicationId={app.applicationId}
                                    systemId={props.system.systemId}
                                    systemName={props.system.systemName}
                                    readonly={props.readonly}
                                    expanded={idx === 0}
                                />
                            ))
                        ) : (
                            <Alert severity="warning">No Applications Found</Alert>
                        )}
                    </Stack>
                </CardContent>
            </Card>
        </>
    );
};

export default SystemApplications;
